module.exports = __webpack_public_path__ + "img/CAPTURE_TAUR_612_carre.e6669cb1.jpg";